import { Button } from '@/common/ui/button'
import { Modal } from '@/common/ui/modal'

type TAlertModalProps = {
	isOpen: boolean
	onClose: () => void
	onConfirm: () => void
	loading: boolean
	title?: string
	description?: string
}
export const AlertModal = ({
	isOpen,
	onClose,
	onConfirm,
	loading,
	title = 'Are you sure?',
	description = 'Are you sure you want to continue?',
}: TAlertModalProps) => {
	return (
		<Modal
			title={title}
			description={description}
			isOpen={isOpen}
			onClose={onClose}
		>
			<div className="flex w-full items-center justify-end space-x-2 pt-6">
				<Button disabled={loading} variant="outline" onClick={onClose}>
					Cancel
				</Button>
				<Button disabled={loading} variant="destructive" onClick={onConfirm}>
					Continue
				</Button>
			</div>
		</Modal>
	)
}
